import { render } from "./QandaQuestion.vue?vue&type=template&id=354c6f76&scoped=true&ts=true"
import script from "./QandaQuestion.vue?vue&type=script&lang=ts"
export * from "./QandaQuestion.vue?vue&type=script&lang=ts"

import "./QandaQuestion.vue?vue&type=style&index=0&id=354c6f76&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354c6f76"]])

export default __exports__